import { GlobalStylesBk } from '@rbilabs/components-library/build/globalStyles';
import { DefaultTheme, GlobalStyleComponent } from 'styled-components';

export const BrandGlobalStyles: GlobalStyleComponent<{}, DefaultTheme> = GlobalStylesBk;
